import React, { useEffect, useState } from "react";
import PlotBackground from "../../assets/svg/PlotListBackground.svg";
import { makeStyles } from "@mui/styles";
import { Typography, Box, Grid, CircularProgress } from "@mui/material";
import ImageGrid from "./ActivityNavigate";
// import Loader from "../../components/Loader";
import instance from "../../globals/axios";
import { getFarmerPlotId } from "../../globals/utils";
import { useTranslation } from "react-i18next";
import CustomAppBar from "../../components/AppBar";

const useStyles = makeStyles(() => ({
  centerCard: {
    display: "flex",
    padding: "20px",
    height: "100%",
    background: `url(${PlotBackground}) center/cover no-repeat`,
  },
  centeredText: {
    textAlign: "center",
    color: "#FFF",
    margin: "20px!important",
    fontFamily: "Inter",
    fontSize: "18px",
    fontWeight: 400,
    lineHeight: "26px",
  },
  cardContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  button: {
    marginTop: "20px",
  },
  text: {
    fontSize: "16px !important",
    fontWeight: "700 !important",
  },
  title: {
    fontSize: "24px !important",
    fontWeight: "700 !important",
  },
  circularProgress: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "80vh",
    marginLeft: "8rem",
  },
}));

const ScheduleActivity = () => {
  const classes = useStyles();
  const farmerPlotId = getFarmerPlotId();
  const [data, setData] = useState([]);
  const { t } = useTranslation();
  const [imageGridLoaded, setImageGridLoaded] = useState(false);
  let id = "";
  let variety = "";
  if (localStorage.getItem("farmerPlotId")) {
    variety = localStorage.getItem("plotVariety");
    id = localStorage.getItem("id");
  }
  const fetchStatus = () => {
    instance
      .get(`plotengagement/get-overall-status?farmer_plot=${farmerPlotId}`)
      .then((res) => {
        setData(res.data);
      });
  };
  useEffect(() => {
    if (farmerPlotId) {
      fetchStatus();
    }
  }, [farmerPlotId]);

  return (
    <div>
      <CustomAppBar />
      <div className={classes.centerCard}>
        <Box mt={12} marginLeft={1}>
          {imageGridLoaded ? (
            <Grid container>
              <Grid item xs={4}>
                <Typography className={classes.text}>
                  {t("Plot")} {id}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.title}>
                  {t("Scheduler")}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <Typography className={classes.text}> {variety}</Typography>
              </Grid>
            </Grid>
          ) : (
            <div className={classes.circularProgress}>
              <CircularProgress />
            </div>
          )}
          <ImageGrid
            farmerPlotId={farmerPlotId}
            variety={variety}
            data={data}
            onImagesLoad={() => setImageGridLoaded(true)}
          />
        </Box>
      </div>
    </div>
  );
};

export default ScheduleActivity;
